import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { curry } from 'fp-ts/lib/function';
import { logging, utils } from '@heimdall/core-common';
import { db } from '@heimdall/core-common-client';
import { Organization } from '@heimdall/core-domain';
var executor = utils.TaskUtils.executeAndDecode(Organization.Organization);
var logger = logging.instantiateLogger('heimdall:app:organization:accessors');
export function getOrganizationDataFunction(_x, _x2) {
  return _getOrganizationDataFunction.apply(this, arguments);
}

function _getOrganizationDataFunction() {
  _getOrganizationDataFunction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(firestore, oid) {
    var log, getDoc, task;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log = logger.extend('getOrganizationDataFunction');
            getDoc = db.Firestore.getDocumentTask(firestore);
            task = getDoc(['organizations', oid]);
            log('Task Created');
            _context.next = 6;
            return executor(task);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getOrganizationDataFunction.apply(this, arguments);
}

export var getOrganizationData = curry(getOrganizationDataFunction);